import dayjs from "dayjs";

import { TableRow } from "@/components/common/table/table";
import { TruncatedText } from "@/components/common/text";
import { formatAge } from "@/utils/date";

const CELL = "px-2 py-2 align-middle";

const formatPlace = (place) => (place ? [place.city, place.state].filter(Boolean).join(", ") : "");

// "~" marks a straight-line estimate, used where the road miles were not available.
const formatDistance = ({ miles, approximate }) =>
    `${approximate ? "~" : ""}${miles < 1 ? "< 1" : Math.round(miles).toLocaleString("en-US")} mi`;

// A single truck row in the truck list table.
export const TruckListRow = ({ truck }) => {
    const location = formatPlace(truck.location);

    return (
        <TableRow className="h-[57px] hover:bg-cm-p-surface-hover">
            <td className={CELL}>
                <span className="whitespace-nowrap text-xs text-cm-p-text-secondary">{formatAge(truck.postedAt)}</span>
            </td>
            <td className={CELL}>
                <span className="text-sm font-medium text-cm-p-text-primary">{truck.truckNumber || truck.driverName || "-"}</span>
            </td>
            <td className={CELL}>
                <div className="flex flex-col">
                    <span className="text-sm font-medium text-cm-p-text-primary">{truck.equipment?.type || "-"}</span>
                    {truck.equipment?.team && <span className="text-xs text-cm-p-text-secondary">Team</span>}
                </div>
            </td>
            <td className={CELL}>
                <div className="flex flex-col">
                    <TruncatedText className="text-sm text-cm-p-text-primary">{location || "-"}</TruncatedText>
                    {truck.distance && (
                        <span
                            className="whitespace-nowrap text-xs text-cm-p-text-secondary"
                            title={truck.distance.approximate ? "Straight-line distance" : "Driving distance"}
                        >
                            {formatDistance(truck.distance)}
                        </span>
                    )}
                </div>
            </td>
            <td className={CELL}>
                <span className="whitespace-nowrap text-sm text-cm-p-text-primary">
                    {/* Ready date is a calendar date; use its yyyy-mm-dd part so it isn't shifted to the viewer's timezone. */}
                    {truck.readyDate ? dayjs(truck.readyDate.slice(0, 10)).format("MMM D, YYYY") : "-"}
                </span>
            </td>
            <td className={CELL}>
                <TruncatedText className="text-sm text-cm-p-text-primary">{truck.dispatcher?.name || "-"}</TruncatedText>
            </td>
            <td className={CELL}>
                <div className="flex flex-col">
                    {truck.contact?.email && (
                        <a href={`mailto:${truck.contact.email}`} className="truncate text-sm font-medium text-cm-p-accent hover:underline">
                            {truck.contact.email}
                        </a>
                    )}
                    {truck.contact?.phone && Number(truck.contact.phone) !== 0 && (
                        <span className="text-xs text-cm-p-text-secondary">{truck.contact.phone}</span>
                    )}
                </div>
            </td>
            <td className={CELL}>
                <TruncatedText className="text-xs text-cm-p-text-secondary">{truck.note || ""}</TruncatedText>
            </td>
        </TableRow>
    );
};
